var map = {
	"./button.wav": 185,
	"./celebration.wav": 311,
	"./clear_piano.wav": 312,
	"./correct_answer_1.mp3": 313,
	"./incorrect_answer_1.mp3": 314,
	"./incorrect_in_print.wav": 315,
	"./print_correct.wav": 316,
	"./tap_01.wav": 106,
	"./tap_02.wav": 107,
	"./tap_03.wav": 108,
	"./tap_04.wav": 109,
	"./tap_05.wav": 110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 554;